import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import FormSpacer from "@saleor/components/FormSpacer";
import { ShopErrorFragment } from "@saleor/fragments/types/ShopErrorFragment";
import { commonMessages } from "@saleor/intl";
import { getFormErrors } from "@saleor/utils/errors";
import getShopErrorMessage from "@saleor/utils/errors/shop";
import React from "react";
import { useIntl } from "react-intl";

import { SiteLanguageDetails_siteLanguage } from "../../types/SiteLanguageDetails";
import { SiteLanguageDetailPageFormData } from "../SiteLanguageDetailPage";

export interface SiteLanguageInfoProps {
  data: SiteLanguageDetailPageFormData;
  disabled: boolean;
  errors: ShopErrorFragment[];
  siteLanguage: SiteLanguageDetails_siteLanguage;
  onChange: (event: React.ChangeEvent<any>) => void;
}

const useStyles = makeStyles(
  {
    root: {
      overflow: "visible"
    }
  },
  { name: "PageInfo" }
);

const SiteLanguageInfo: React.FC<SiteLanguageInfoProps> = props => {
  const { data, disabled, errors, onChange } = props;

  const classes = useStyles(props);
  const intl = useIntl();

  const formErrors = getFormErrors(
    ["name", "language", "domain", "isActive"],
    errors
  );

  return (
    <Card className={classes.root}>
      <CardTitle
        title={intl.formatMessage(commonMessages.generalInformations)}
      />
      <CardContent>
        <TextField
          disabled={disabled}
          error={!!formErrors.language}
          fullWidth
          helperText={getShopErrorMessage(formErrors.language, intl)}
          label={intl.formatMessage({
            defaultMessage: "Name",
            description: "site language name"
          })}
          name={"language" as keyof SiteLanguageDetailPageFormData}
          value={data.language}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          error={!!formErrors.domain}
          fullWidth
          helperText={getShopErrorMessage(formErrors.domain, intl)}
          label={intl.formatMessage({
            defaultMessage: "Domain",
            description: "site language domain"
          })}
          name={"domain" as keyof SiteLanguageDetailPageFormData}
          value={data.domain}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          error={!!formErrors.name}
          fullWidth
          helperText={getShopErrorMessage(formErrors.name, intl)}
          label={intl.formatMessage({
            defaultMessage: "Language Code",
            description: "site language language"
          })}
          name={"name" as keyof SiteLanguageDetailPageFormData}
          value={data.name}
          onChange={onChange}
        />
        <FormSpacer />
        <ControlledCheckbox
          name={"isActive" as keyof SiteLanguageDetailPageFormData}
          label={intl.formatMessage({
            defaultMessage: "Active",
            description: "check to require active to have value"
          })}
          checked={data.isActive}
          onChange={onChange}
          disabled={disabled}
        />
      </CardContent>
    </Card>
  );
};
SiteLanguageInfo.displayName = "SiteLanguageInfo";
export default SiteLanguageInfo;
